const mapInfo = [
  {
    title: 'Shopping',
    fill: '#FF7802',
    points: [
      {
        name: 'Columbia Street',
        left: '45%',
        top: '50%',
      },
      {
        name: 'Columbia Square Plaza',
        left: '19%',
        top: '70.5%',
      },
      {
        name: 'River Market',
        left: '30%',
        top: '81.5%',
      },
      {
        name: 'Front Street Mews',
        left: '43.5%',
        top: '58%',
      },
      {
        name: 'Farmers Market',
        left: '39%',
        top: '18%',
      },
      {
        name: 'Royal City Centre',
        left: '5%',
        top: '8%',
      },
    ],
  },
  {
    title: 'Services',
    fill: '#449FC2',
    points: [
      {
        name: 'Anvil Centre',
        left: '31%',
        top: '62%',
      },
      {
        name: 'Fraser River Discovery Centre',
        left: '36.5%',
        top: '75%',
      },
      {
        name: 'New Westminster Museum and Archives',
        left: '32.7%',
        top: '63.5%',
      },
      {
        name: 'Public Library',
        left: '6.5%',
        top: '11%',
      },
    ],
  },
  {
    title: 'Dining',
    fill: '#0C1A26',
    points: [
      {
        name: 'Old Crow Coffee Co.',
        left: '39.5%',
        top: '59.5%',
      },
      {
        name: 'El Santo',
        left: '38.5%',
        top: '61%',
      },
      {
        name: 'The Boathouse',
        left: '31%',
        top: '80%',
      },
      {
        name: 'Longtail Kitchen',
        left: '32.5%',
        top: '78.5%',
      },
      {
        name: 'Taverna Greka',
        left: '49%',
        top: '44.5%',
      },
      {
        name: 'Stefanos',
        left: '50%',
        top: '40%',
      },
      {
        name: 'The Heritage Grill',
        left: '44.7%',
        top: '47.5%',
      },
      {
        name: 'Judge Begbie’s Tavern',
        left: '40%',
        top: '54%',
      },
      {
        name: 'Banh Mi Bar',
        left: '33.5%',
        top: '57.5%',
      },
    ],
  },
  {
    title: 'Schools',
    fill: '#757779',
    points: [
      {
        name: 'Douglas College',
        left: '28.5%',
        top: '55%',
      },
      {
        name: 'Fraser River Middle School',
        left: '19.5%',
        top: '45%',
      },
      {
        name: 'École Qayqayt Elementary',
        left: '47%',
        top: '21.5%',
      },
      {
        name: 'Graham Montessori Daycare',
        left: '16.5%',
        top: '60.5%',
      },
      {
        name: 'Urban Academy',
        left: '44%',
        top: '19.5%',
      },
    ],
  },
  {
    title: 'Parks',
    fill: '#498853',
    points: [
      {
        name: 'Waterfront Esplanade',
        left: '5.2%',
        top: '86.5%',
      },
      {
        name: 'Westminster Pier Park',
        left: '53%',
        top: '46.5%',
      },
      {
        name: 'Tipperary Park',
        left: '39%',
        top: '23%',
      },
      {
        name: 'Albert Crescent Park',
        left: '58%',
        top: '23%',
      },
      {
        name: 'Simcoe Park',
        left: '18%',
        top: '53%',
      },
      {
        name: 'Toronto Place Park',
        left: '24.5%',
        top: '48%',
      },
      {
        name: 'Brownsville Bar Beach',
        left: '89.5%',
        top: '38%',
      },
      {
        name: 'Tannery Park',
        left: '83%',
        top: '93%',
      },
    ],
  },
];

export default mapInfo;



// WEBPACK FOOTER //
// ./src/data/map.js